import { useLanguage } from '@/contexts/LanguageContext';
import { motion } from 'framer-motion';

const RATE = 2.80;
const routes = [
  { from: 'Salzburg', to: 'Airport (SZG)', km: 5 },
  { from: 'Salzburg', to: 'Hallstatt', km: 75 },
  { from: 'Salzburg', to: 'Zell am See', km: 85 },
  { from: 'Salzburg', to: 'Berchtesgaden', km: 30 },
  { from: 'Salzburg', to: "Eagle's Nest", km: 35 },
  { from: 'Salzburg', to: 'Bad Gastein', km: 100 },
  { from: 'Salzburg', to: 'Linz', km: 125 },
  { from: 'Salzburg', to: 'München', km: 150 },
  { from: 'Salzburg', to: 'Innsbruck', km: 185 },
  { from: 'Salzburg', to: 'Český Krumlov', km: 205 },
  { from: 'Salzburg', to: 'Graz', km: 285 },
  { from: 'Salzburg', to: 'Wien', km: 300 },
];

const PricingTable = () => {
  const { t, lang } = useLanguage();
  const currency = lang === 'en' ? '$' : '€';

  return (
    <section id="pricing" className="py-20 md:py-28 bg-muted">
      <div className="container">
        <div className="text-center mb-16">
          <h2 className="font-display text-3xl md:text-4xl font-bold text-foreground mb-4">{t.pricing.title}</h2>
          <p className="text-muted-foreground text-lg max-w-xl mx-auto">{t.pricing.subtitle}</p>
          <div className="w-16 h-1 bg-gradient-gold mx-auto mt-6 rounded-full" />
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="max-w-3xl mx-auto overflow-hidden rounded-2xl shadow-card"
        >
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="bg-gradient-gold">
                  <th className="px-6 py-4 text-left text-primary-foreground font-display font-semibold">{t.pricing.route}</th>
                  <th className="px-6 py-4 text-left text-primary-foreground font-display font-semibold">{t.pricing.distance}</th>
                  <th className="px-6 py-4 text-left text-primary-foreground font-display font-semibold">{t.pricing.price}</th>
                </tr>
              </thead>
              <tbody>
                {routes.map((r, i) => (
                  <tr key={i} className={`${i % 2 === 0 ? 'bg-card' : 'bg-muted'} hover:bg-primary/5 transition-colors`}>
                    <td className="px-6 py-4 font-medium text-foreground">{r.from} → {r.to}</td>
                    <td className="px-6 py-4 text-muted-foreground">{r.km} km</td>
                    <td className="px-6 py-4 font-semibold text-foreground">{currency}{(r.km * RATE).toFixed(0)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </motion.div>

        <p className="text-center text-muted-foreground text-sm mt-6">
          Van ×1.3 | VIP ×1.5 · {currency}{RATE.toFixed(2)}/km
        </p>
      </div>
    </section>
  );
};

export default PricingTable;
